import api from './api';

// Store simple pour le nonce (équivalent à un useState global)
/**
 * Récupère un nouveau nonce depuis l'API
 */
export const getNonce = async () => {
  try {
    const response = await api.post('/generateNonce');
    const { nonce, token } = response.data;
    return { nonce, token };
  } catch (error) {
    console.error('Erreur lors de la récupération du nonce:', error);
    throw error;
  }
};


/**
 * Ajoute le nonce aux données pour l'envoi à l'API
 */
export const addNonceToData = async (data) => {
  const { nonce, token } = await getNonce();
  return {
    ...data,
    nonce,
    token
  };
};


// Export par défaut pour compatibilité
const nonceService = {
  getNonce,
  addNonceToData,
};

export default nonceService; 